import React from 'react';
import { Modal, ModalContent, ModalBody, ModalCloseBtn } from '@fiverr-private/overlay';
import { Image } from '@fiverr-private/media';
import { Stack, Container } from '@fiverr-private/layout_components';
import { ModalComponentProps } from '@fiverr-private/jtbd_sdk';
import { Heading, Text, Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Box } from '@fiverr-private/theme';

const ModalComponent = (props: ModalComponentProps) => {
    const { isOpen, onClose } = props;

    const onCloseModal = () => {
        onClose();
    };

    return (
        <Modal isOpen={isOpen}>
            <ModalContent size="sm">
                <Container display="flex" justifyContent="center">
                    <Image
                        height="272px"
                        src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/d50c761638a6edfaff2242060f5af5ed-1743935279743/modal_header.jpg"
                        alt="Download App"
                    ></Image>
                    <Container position="absolute" right={10} top={4}>
                        <ModalCloseBtn theme="light" onClick={onCloseModal} />
                    </Container>
                </Container>
                <ModalBody topPadding={true}>
                    <Stack direction="column" justifyContent="center">
                        <Heading size="h_lg" alignSelf="center">
                            <I18n k={'jobs_tbd.download_app.modal.header'} />
                        </Heading>
                        <Text alignSelf="center" textAlign="center">
                            <I18n k={'jobs_tbd.download_app.modal.main_text'} />
                        </Text>
                        <Typography alignSelf="center" color="grey_1100">
                            <I18n k={'jobs_tbd.download_app.modal.qr_text'} />
                        </Typography>
                        <Box display="flex" justifyContent="center" alignItems="center" alignSelf="center">
                            <Image
                                src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/f9b16a1f2b91a4786991f5a51b0910ed-1743945625659/qr_code.jpg"
                                width="120px"
                                height="120px"
                                alt="QR code"
                            ></Image>
                        </Box>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ModalComponent;
